"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractFileRoutes = void 0;
var ContractFileRoutes;
(function (ContractFileRoutes) {
    ContractFileRoutes["BasePrefix"] = "contract-files";
    ContractFileRoutes["ById"] = ":contractFileId";
    ContractFileRoutes["AllByContractId"] = "all/:contractId";
})(ContractFileRoutes = exports.ContractFileRoutes || (exports.ContractFileRoutes = {}));
